import { AfterViewInit, Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { SetCurrentElementId, SetCurrentElementObject } from 'src/app/shared/store/shared.actions';
import { Observable, Subscription, combineLatest, map, of, startWith, take, tap } from 'rxjs';
import { IBrand } from 'src/app/features/brands/models/brands.models';
import { FetchAllBrands } from 'src/app/features/brands/store/brands.actions';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { AddCustomer, AddCustomerSuccess, AddLocation, AddLocationSuccess, FetchAllCountries, FetchAllCurrencies, FetchAllpaymentTerms, FetchAllStates, GetCompanyById, GetCompanyByIdSuccess, GetCustomerById, GetCustomerByIdSuccess, UpdateCustomer, UpdateCustomerSuccess } from '../../store/customers.actions';
import { CreateLocationPayload, ICountry, ICurrency, ICustomer, IFile, ILocation, IMainContact, IPayment_term, IState, SelectedCatalogsData } from '../../models/customers.models';
import { emailValidator, numericOnlyValidator } from 'src/app/shared/validators/fields-validators';
import { ITag } from 'src/app/features/tags/models/tags.models';
import { ICategory } from 'src/app/features/categories/models/categories.models';
import { FetchAllTags } from 'src/app/features/tags/store/tags.actions';
import { FetchAllCategories } from 'src/app/features/categories/store/categories.actions';
import { ICatalog } from 'src/app/features/catalogs/models/catalogs.models';
import { ICompaniesGroups } from 'src/app/features/companies-groups/models/companies-groups.model';
import { AddCompaniesGroupeSuccess, FetchCompaniesGroups } from 'src/app/features/companies-groups/store/companies-groups.actions';
import { MatStepper } from '@angular/material/stepper';
import { MatDialog } from '@angular/material/dialog';
import { EditBasicCutomInfoComponent } from '../edit-basic-cutom-info/edit-basic-cutom-info.component';
import { EditAddressComponent } from '../edit-address/edit-address.component';
import { AddContactsComponent } from '../add-contacts/add-contacts.component';
import { EditCustomInvoicComponent } from '../edit-custom-invoic/edit-custom-invoic.component';
import { EditFilesComponent } from '../edit-files/edit-files.component';
import { TranslateService } from '@ngx-translate/core';
import { AddElementsComponent } from 'src/app/features/produits/components/add-elements/add-elements.component';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { CommonService } from 'src/app/shared/common.service';
import { ZodValidatorService } from 'src/app/shared/zod-validator/zod-validator.service';
import { step1Schema } from '../../validators/customer.zod.validator';
import { FilesDialogPreviewerComponent } from 'src/app/shared/files-dialog-previewer/files-dialog-previewer.component';

declare var google: any;
@Component({
  selector: 'app-add-customers',
  templateUrl: './add-customers.component.html',
  styleUrls: ['./add-customers.component.scss']
})
export class AddCustomersComponent implements OnInit, AfterViewInit {
  @ViewChildren(MatAutocompleteTrigger) autocompleteTriggers!: QueryList<MatAutocompleteTrigger>;

  @ViewChild('stepper') stepper: MatStepper | undefined;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  private subscriptions: Subscription[] = [];
  isnertStep: string = ''
  form!: FormGroup;
  locationForm!: FormGroup;
  mainContactForm!: FormGroup;
  customerId!: number;
  locationId!: number;
  customer!: ICustomer;
  mainLocation!: ILocation;
  params: any;
  brands$: Observable<IBrand[]> = of([]);
  groupes$: Observable<ICompaniesGroups[]> = of([]);
  tags$: Observable<ITag[]> = of([]);
  categories$: Observable<ICategory[]> = of([]);
  filteredBrands$!: Observable<IBrand[]>;
  filteredGroupes$!: Observable<ICompaniesGroups[]>;
  filteredTags$!: Observable<ITag[]>;
  filteredCategories$!: Observable<ICategory[]>;
  blacklist_brands: IBrand[] = []
  favorit_brands: IBrand[] = [];
  groupes: ICompaniesGroups[] = [];
  tags: ITag[] = [];
  categories: ICategory[] = [];
  locations: ILocation[] = [];
  mainContacts: IMainContact[] = [];
  expandedIndex: number = -1;
  expandedContactIndex: number = -1;
  currentLocationIndex: number = -1;
  currentContactIndex: number = -1;
  currentLocationName: string = '';
  isUpdated: boolean = false;
  isContactUpdated: boolean = false;
  paymentTerms$: Observable<IPayment_term[]> = of([]);
  paymentTerms: IPayment_term[] = [];
  countries$: Observable<ICountry[]> = of([]);
  countries: ICountry[] = [];
  states$: Observable<IState[]> = of([]);
  states: IState[] = [];
  currencies$: Observable<ICurrency[]> = of([]);
  currencies: ICurrency[] = [];
  CurrentMode: string = 'new'
  selectedCatalogs: ICatalog[] = [];
  currentForm: string = 'addCustomer';
  currentCustomDiscount!: number;
  editCustom: boolean = false;
  files?: IFile[];
  selectedFiles: IFile[] = [];
  country!: string;
  state!: string;
  city!: string;
  zip!: string;
  billing_country!: string;
  billing_state!: string;
  billing_city!: string;
  billing_zip!: string;
  lang!: string;
  hideEditButton = false

  currentStep = 1;

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private actions$: Actions,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private commonService: CommonService,
    private zodValidatorService: ZodValidatorService,
    public featureFlagService: FeatureFlagService,
  ) { }

  ngOnInit(): void {
    const sub3 = this.activatedRoute.queryParams.subscribe(params => {
      if (params['action'] === 'edit') {
        this.CurrentMode = 'edit';
        this.locationId = +this.activatedRoute.snapshot.paramMap.get('id')!;
      } else if (params['action'] === 'add') {
        this.CurrentMode = 'add';
        this.customerId = +this.activatedRoute.snapshot.paramMap.get('company_id')!;
        this.params = params
        setTimeout(() => {
          this.initializeForm(params);
          this.form.get('name')?.disable();
          this.form.get('company_id')?.disable();
        }, 0);
      }
    });
    this.store.dispatch(FetchAllpaymentTerms());
    this.store.dispatch(FetchAllCountries());
    this.store.dispatch(FetchAllStates());
    this.store.dispatch(FetchAllCurrencies());
    this.store.dispatch(FetchAllBrands({}));
    this.store.dispatch(FetchAllTags({}));
    this.store.dispatch(FetchAllCategories({}));
    this.store.dispatch(FetchCompaniesGroups({}));
    this.initializeForm();
    this.initializeMainContactForm();
    this.initializeLocationForm();
    this.paymentTerms$ = this.store.select((state) => [...state.customers.allPaymentTerms].sort((a, b) => a.name.localeCompare(b.name)));
    this.countries$ = this.store.select((state) => state.customers.allCountries);
    this.states$ = this.store.select((state) => state.customers.allStates);
    this.currencies$ = this.store.select((state) => state.customers.allCurrencies);

    const sub4 = this.states$.subscribe((states) => {
      this.states = states;
    })
    const sub5 = this.countries$.subscribe((countries) => {
      this.countries = countries;
    })
    const sub6 = this.currencies$.subscribe((currencies) => {
      this.currencies = currencies;
    })

    const sub8 = this.paymentTerms$.subscribe((paymentTerms) => {
      this.paymentTerms = paymentTerms;
    })

    this.brands$ = this.store.select((state) => [...state.brands.allBrands].sort((a, b) => a.name.localeCompare(b.name)));
    this.groupes$ = this.store.select((state) => [...state.companiesGroups.AllCompaniesGroups].sort((a, b) => a.name.localeCompare(b.name)));
    this.tags$ = this.store.select((state) => [...state.tags.allTags].sort((a, b) => a.name.localeCompare(b.name)));
    this.categories$ = this.store.select((state) => [...state.categories.allCategories].sort((a, b) => a.name.localeCompare(b.name)));
    if (this.locationId) {
      this.store.dispatch(SetCurrentElementId({ currentElementId: this.locationId }));
      this.store.dispatch(GetCustomerById({ id: this.locationId }));
    }
    if (this.customerId) {
      this.store.dispatch(SetCurrentElementObject({ currentElementObject: { id: this.customerId!, name: this.params.name, company_id: this.params.company_id } }));
      this.store.dispatch(GetCompanyById({ id: this.customerId }));
    }
    const sub1 = this.actions$.pipe(
      ofType(GetCustomerByIdSuccess),
      tap((action) => {
        this.customer = action.customer;
        this.initializeLocationForm(action.customer.location);
        this.mainContacts = action.customer.location!.contacts_information.map((contact) => {
          return {
            ...contact
          }
        });
        if( action.customer.location){
          this.selectedCatalogs = action.customer.location?.catalogs!.map((catalog: ICatalog) =>{
            return {
              ...catalog,
              additional_discount: catalog.additional_discount ? catalog.additional_discount : action.customer.location?.custom_discount
            }
          });
        }
        this.openContact(this.mainContacts[0], 0)
        this.blacklist_brands = action.customer.location?.blacklist_brands!
        this.favorit_brands = action.customer.location?.favorit_brands!
        this.groupes = action.customer.location?.groups!
        this.tags = action.customer.location?.tags!
        this.categories = action.customer.location?.categories!
        this.initializeForm(action.customer);
        if (action.customer.location?.is_main === false) {
          this.form.get('name')?.disable();
          this.form.get('company_id')?.disable();
        }
      })).subscribe();

    const sub7 = this.actions$.pipe(
      ofType(GetCompanyByIdSuccess),
      tap((action) => {
        this.mainLocation = action.company.locations?.find((location) => location.is_main === true)!;
        this.hideEditButton = !!action.company.locations?.find((location) => location.is_main === true);
      })).subscribe()

    const sub2 = this.actions$.pipe(
      ofType(AddCustomerSuccess, UpdateCustomerSuccess, AddLocationSuccess),
      tap(() => {
        this.router.navigate(['companies'])

      })).subscribe()

    this.filteredBrands$ = combineLatest([
      this.brands$,
      this.form.get('brandControl')!.valueChanges.pipe(
        startWith('')
      ),
    ]).pipe(
      map(([brands, input]) => this._filterStrings(brands, input))
    );

    this.filteredGroupes$ = combineLatest([
      this.groupes$,
      this.form.get('groupeControl')!.valueChanges.pipe(
        startWith('')
      ),
    ]).pipe(
      map(([groupes, input]) => this._filterStrings(groupes, input))
    );

    this.filteredTags$ = combineLatest([
      this.tags$,
      this.form.get('tagControl')!.valueChanges.pipe(
        startWith('')
      ),
    ]).pipe(
      map(([tags, input]) => this._filterStrings(tags, input))
    );

    this.filteredCategories$ = combineLatest([
      this.categories$,
      this.form.get('categoryControl')!.valueChanges.pipe(
        startWith('')
      ),
    ]).pipe(
      map(([categories, input]) => this._filterStrings(categories, input))
    );

    const sub9 = this.actions$
      .pipe(
        ofType(AddCompaniesGroupeSuccess),
        tap((action) => {
          this.onGroupeSelected(action.companiesGroup)
        })
      )
      .subscribe();

    this.subscriptions.push(sub1, sub2, sub3, sub4, sub5, sub6, sub7, sub8, sub9);
  }

  ngAfterViewInit(): void {
    this.addressAutoComplete('apartment');
    this.addressAutoComplete('billing_apartment');
  }

  addressAutoComplete(elementId: string): boolean | void {
    const center = { lat: 50.064192, lng: -130.605469 };
    // Create a bounding box with sides ~10km away from the center point
    const defaultBounds = {
      north: center.lat + 0.1,
      south: center.lat - 0.1,
      east: center.lng + 0.1,
      west: center.lng - 0.1,
    };
    const input = document.getElementById(elementId) as HTMLInputElement;
    const options = {
      bounds: defaultBounds,
      strictBounds: false,
    };

    if (!input) {
      console.error(`Element with id '${elementId}' not found`);
      return;
    }

    const autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();

      if (!place) {
        console.error('No place found');
        return;
      }
      const address = place.formatted_address;
      let country = '';
      let state = '';
      let city = '';
      let zipCode = '';
      let short_name = ''
      // Extract country and state from address_components
      place.address_components.forEach((component: { types: string | string[]; long_name: string; short_name: string}) => {
        if (component.types.includes('country')) {
          country = component.long_name; // or component.short_name for ISO code
        }
        if (component.types.includes('administrative_area_level_1')) {
          state = component.long_name; // or component.short_name for abbreviation
        }
        if (component.types.includes('administrative_area_level_2')) {
          city = component.long_name;
        }
        if (component.types.includes('postal_code')) {
          zipCode = component.long_name;
        }
        if(component.types.includes('country')) {
          short_name = component.short_name
        }
      });

      if (elementId === 'apartment') {
        this.lang = short_name === 'IT' ? 'it_IT' : short_name === 'FR' ? 'fr_FR' : short_name === 'US' ? 'en_US' : 'it_IT';
        const apartment = place.formatted_address;
        this.locationForm
        .get('apartment')
        ?.patchValue(apartment);
        this.country = country;
        this.state = state;
        this.city = city;
        this.zip = zipCode;
        if (this.locationForm.get('is_bill_same')?.value === true) {
          this.locationForm.get('billing_apartment')?.setValue(apartment);
          this.billing_country = country;
          this.billing_state = state;
          this.billing_city = city;
          this.billing_zip = zipCode;
        }
      }
      if (elementId === 'billing_apartment' && this.locationForm.get('is_bill_same')?.value === false) {
        const billing_apartment = place.formatted_address;
        this.locationForm
        .get('billing_apartment')
        ?.patchValue(billing_apartment);
        this.billing_country = country;
        this.billing_state = state;
        this.billing_city = city;
        this.billing_zip = zipCode;
      }
    });
  }

  private initializeForm(customerForm?: any): void {
    this.form = this.fb.group({
      name: new FormControl(customerForm?.name ?? '', Validators.required),
      company_id: new FormControl(customerForm?.company_id ?? ''),
      brandControl: new FormControl(''),
      groupeControl: new FormControl(''),
      categoryControl: new FormControl(''),
      tagControl: new FormControl(''),
    });
  }

  private initializeLocationForm(location?: ILocation): void {
    this.locationForm = this.fb.group({
      name: new FormControl(location?.name ?? '', Validators.required),
      currency: new FormControl(location?.currency?.id ?? ''),
      tax: new FormControl(location?.tax ?? ''),
      tax_id: new FormControl(location?.tax_id ?? ''),
      custom_discount: new FormControl(location?.custom_discount ?? ''),
      apartment: new FormControl(location?.apartment ?? '', Validators.required),
      billing_apartment: new FormControl(location?.billing_apartment ?? '', Validators.required),
      is_bill_same: new FormControl(false),
      is_bill_same_as_main: new FormControl(false),
      payment_terms: new FormControl(location?.payment_terms?.id ?? ''),
    })
  }

  private initializeMainContactForm(mainContat?: IMainContact): void {
    this.mainContactForm = this.fb.group({
      id: new FormControl(mainContat?.id ?? ''),
      contact_fname: new FormControl(mainContat?.contact_fname ?? '', Validators.required),
      contact_lname: new FormControl(mainContat?.contact_lname ?? null),
      email: new FormControl(mainContat?.email ?? '', [Validators.required, emailValidator()]),
      phone: new FormControl(mainContat?.phone ?? '',numericOnlyValidator()),
      receive_emails: new FormControl(mainContat?.receive_emails ?? true),
      receive_sms: new FormControl(mainContat?.receive_sms ?? ''),
      is_user: new FormControl(mainContat?.is_user ?? false),
      lang: new FormControl(mainContat?.lang ?? 'it_IT', [Validators.required]),
      signature: new FormControl(mainContat?.signature ?? '')
    })
  }

  copyShippingToBilling() {
    this.locationForm.patchValue({
      billing_apartment: this.locationForm.get('apartment')?.value,
    });
    this.billing_country = this.country;
    this.billing_state = this.state;
    this.billing_city = this.city;
    this.billing_zip = this.zip;
  }

  copyMainBillingToBilling() {
    this.locationForm.patchValue({
      billing_apartment: this.mainLocation.billing_apartment,
    });
  }

  clearBilling() {
    this.locationForm.patchValue({
      billing_apartment: '',
    });
  }

  private _filterStrings(strings: any[], value: string): any[] {
    const filterValue = this._normalizeValue(value);
    return strings.filter((string) =>
      this._normalizeValue(string.name)?.includes(filterValue!)
    );
  }
  private _normalizeValue(value: string | undefined): string | undefined {
    return value?.toLowerCase().replace(/\s/g, '');
  }


  toggleBillingAddress(): boolean | void {
    if (this.locationForm.get('apartment')?.invalid) {
      this.locationForm.get('apartment')?.markAsTouched()
      this.locationForm.get('is_bill_same')?.setValue(false)
      return false
    }
    const sameAsShipping = this.locationForm.get('is_bill_same')?.value;
    if (sameAsShipping) {
      this.copyShippingToBilling();
    }else {
      this.clearBilling()
    }
  }

  toggleBillingAddressAsMain() {
    const sameAsShipping = this.locationForm.get('is_bill_same_as_main')?.value;
    if (sameAsShipping) {
      this.copyMainBillingToBilling();
    }else {
      this.clearBilling()
    }
  }

  toggleContacts(event: any) {
    const checked = event.checked;
    if (checked) {
      this.copyMainContatcs();
    }else {
      this.clearContacts()
    }
  }

  copyMainContatcs(){
    this.mainContacts = this.mainLocation.contacts_information.map((contact: IMainContact) => {
      return {
        ...contact
      }
    });
  }

  clearContacts(){
    this.mainContacts = [];
  }

onGeneralDiscountChange(event: any) {
  const input = event.target;
  const value = input.value < 0 ? 0 : input.value > 100 ? 100 : input.value;
  input.value = value
  this.locationForm.get('custom_discount')?.setValue(value);
  this.selectedCatalogs = this.selectedCatalogs.map((catalog: ICatalog, index) => {
    return {
      ...catalog,
      additional_discount: value,
    }
  })
}

  goTo(form: string, currentStep: string) {
    this.currentForm = form;
    console.log('Step', currentStep)
    this.isnertStep = currentStep;
    const CustomeDiscount = this.locationForm.get('custom_discount')?.value;
    this.currentCustomDiscount = CustomeDiscount ? CustomeDiscount : undefined;
    this.editCustom = true
  }

  onSaveCatalogs(selectedCatalogsData: SelectedCatalogsData) {
    this.selectedCatalogs = selectedCatalogsData.selectedCatalogs;
    this.currentForm = 'addCustomer';
  }

  removeCatalog(id: number){
    this.selectedCatalogs = this.selectedCatalogs.filter((catalog: ICatalog) => catalog.id !== id)
  }

  editBasicInfo(){
    const dialogRef = this.dialog.open(EditBasicCutomInfoComponent,{
      data: {
        name: this.form.get('name')?.value,
        company_id: this.form.get('company_id')?.value
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.form.get('name')?.setValue(result.name);
        this.form.get('company_id')?.setValue(result.company_id);
      }
    });
  }

  editAddress(){
    const dialogRef = this.dialog.open(EditAddressComponent,{
      data: {
        name: this.locationForm.get('name')?.value,
        apartment: this.locationForm.get('apartment')?.value,
        billing_apartment: this.locationForm.get('billing_apartment')?.value,
        is_bill_same: this.locationForm.get('is_bill_same')?.value
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.locationForm.get('name')?.setValue(result.name);
        this.locationForm.get('apartment')?.setValue(result.apartment);
        this.locationForm.get('billing_apartment')?.setValue(result.billing_apartment);
        this.locationForm.get('is_bill_same')?.setValue(result.is_bill_same);
      }
    });
  }

  editContacts(contact?: IMainContact) {
    const dialogRef = this.dialog.open(AddContactsComponent, {
      data: {
        contacts_information: this.mainContacts,
        currentContact: contact
      },
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe((result: IMainContact[]) => {
      if (result) {
        this.mainContacts = result
      }
    });
  }

  editInvoicing(){
    const dialogRef = this.dialog.open(EditCustomInvoicComponent, {
      data: {
        paymentTerms: this.paymentTerms,
        currencies: this.currencies,
        payment_terms: this.locationForm.get('payment_terms')?.value,
        currency: this.locationForm.get('currency')?.value,
        tax_id: this.locationForm.get('tax_id')?.value,
        tax: this.locationForm.get('tax')?.value
      },
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.locationForm.get('payment_terms')?.setValue(result.payment_terms);
        this.locationForm.get('currency')?.setValue(result.currency);
        this.locationForm.get('tax_id')?.setValue(result.tax_id);
        this.locationForm.get('tax')?.setValue(result.tax);
      }
    });
  }

  next(currentStep?: string): boolean | void {
    if(currentStep === 'basic_infos' && (this.form.get('name')?.invalid || this.form.get('company_id')?.invalid || this.locationForm.get('name')?.invalid || this.locationForm.get('apartment')?.invalid || this.locationForm.get('billing_apartment')?.invalid)) {
      this.form.get('name')?.markAsTouched();
      this.form.get('company_id')?.markAsTouched();
      this.locationForm.get('name')?.markAsTouched();
      this.locationForm.get('apartment')?.markAsTouched();
      this.locationForm.get('billing_apartment')?.markAsTouched();
      return false
    } else if(currentStep === 'invoicing' && (this.locationForm.get('payment_terms')?.invalid || this.locationForm.get('currency')?.invalid || this.locationForm.get('tax')?.invalid || this.locationForm.get('tax_id')?.invalid)) {
      this.locationForm.get('payment_terms')?.markAsTouched();
      this.locationForm.get('currency')?.markAsTouched();
      this.locationForm.get('tax')?.markAsTouched();
      return false
    }
    this.form.get('brandControl')?.setValue('');
    this.form.get('groupeControl')?.setValue('');
    this.form.get('tagControl')?.setValue('');
    this.form.get('categoryControl')?.setValue('');

    if(this.isStepValid()) {
      this.stepper?.next();
    }
  }

  isStepValid() {
    this.currentStep = this.stepper ? this.stepper?.selectedIndex + 1 : 0; // If stepper is undefined set currentStep to an unkown step so the stepValidation get bypassed

    return this.validateStep(this.currentStep)
  }

  validateStep(step: number) {
    let stepSchema : any = null;
    let stepData : any = null;

    if(step === 1) {
      stepData = {
        ...this.form.getRawValue(),
        location: this.locationForm.getRawValue(),
        files: this.selectedFiles.map((file) => { return {file: file.file} })
      }

      stepSchema = step1Schema
    }

    if(step === 2) {
      stepData = this.mainContacts

      // stepSchema = step2Schema
    }

    if(step === 3) {
      return true;
    }

    if(stepSchema && stepData) {
      console.log(`Validating step ${step} data: `, stepData)
      const result = this.zodValidatorService.validate(stepSchema, stepData, {returnErrors: false, translationKey: 'company.step' + step })
      console.log('Validation result', result)
      return result.success
    }

    return true;
  }

  back(){
    this.currentStep = this.stepper ? this.stepper?.selectedIndex + 1 : 0;
    this.stepper?.previous();
    this.form.get('brandControl')?.setValue('');
    this.form.get('groupeControl')?.setValue('');
    this.form.get('tagControl')?.setValue('');
    this.form.get('categoryControl')?.setValue('');
  }

  paymentTerm(term_id: number): string | undefined {
    const term = this.paymentTerms.find((term: IPayment_term) => term.id === +term_id);
    return term?.id ? this.translateService.instant( term.name) : '';
  }
  currency(currency_id: number): ICurrency | undefined {
    const currency = this.currencies.find((currenc: ICurrency) => currenc.id === +currency_id);
    return currency ? currency : undefined;
  }

  sumDiscount(a: number, b: number): number {
    const A = +a / 100;
    const B = +b / 100;
    return Math.ceil(
      parseFloat(
        ((A + B - (A * B)) * 100).toFixed(1)
      )
    )
  }

  saveCustomeDiscount(customDiscount: number) {
    this.currentCustomDiscount = customDiscount;
    this.locationForm.get('custom_discount')?.setValue(customDiscount)
  }

  saveContact(): boolean | void {
    if (this.mainContactForm.invalid) {
      this.mainContactForm.markAllAsTouched();
      return false
    }
    const newEmail = this.mainContactForm.value.email.trim().toLowerCase();
    // Check if the email already exists in mainContacts
    if (this.isDuplicateEmail(newEmail, this.mainContacts)) {
      this.mainContactForm.get('email')?.setErrors({ duplicateEmail: true });
      return false;
    }
    this.mainContacts.push({ ...this.mainContactForm.value });
    this.openContact(this.mainContactForm.value, this.mainContacts.length - 1)
  }

  addContact(): boolean | void {
    if (this.mainContactForm.invalid) {
      this.mainContactForm.markAllAsTouched();
      return false
    }
    const newEmail = this.mainContactForm.value.email.trim().toLowerCase();
    // Check if the email already exists in mainContacts
    if (this.isDuplicateEmail(newEmail, this.mainContacts)) {
      this.mainContactForm.get('email')?.setErrors({ duplicateEmail: true });
      return false;
    }
    this.mainContacts.push({ ...this.mainContactForm.value });
    this.mainContactForm.reset();
  }

  updateContact(): boolean | void {
    if (this.mainContactForm.invalid) {
      this.mainContactForm.markAllAsTouched();
      return false
    }
    if (this.currentContactIndex >= 0) {
      const newEmail = this.mainContactForm.value.email.trim().toLowerCase();
      // Check if the email already exists in mainContacts
      if (this.isDuplicateEmail(newEmail, this.mainContacts.filter((contact, index) => index !== this.currentContactIndex))) {
        this.mainContactForm.get('email')?.setErrors({ duplicateEmail: true });
        return false;
      }
      this.mainContacts = this.mainContacts.map((contact, index) => {
        if (this.currentContactIndex === index) {
          return this.mainContactForm.value
        } else {
          return {
            ...contact
          }
        }
      })
      this.isContactUpdated = false;
      this.mainContactForm.reset();
      this.expandedContactIndex = -1;
      this.currentContactIndex = -1;
    }
  }

  openContact(contact: IMainContact, id: number) {
    this.expandedContactIndex = this.expandedContactIndex === id ? -1 : id;
    if (this.expandedContactIndex === id) {
      this.initializeMainContactForm(contact);
      this.currentContactIndex = id;
      this.isContactUpdated = true
    } else {
      this.initializeMainContactForm();
      this.currentContactIndex = -1;
      this.isContactUpdated = false;
    }
  }

  removeContact(i: number) {
    this.mainContacts = this.mainContacts.filter((contact, index) => index !== i);
    this.currentContactIndex = -1;
    this.mainContactForm.reset();
    this.isContactUpdated = false;
    this.expandedContactIndex = -1
  }

  onBlackListBrandSelected(brand: IBrand) {
    if (brand) {
      this.form.get('brandControl')?.setValue('');
      const index1 = this.blacklist_brands.find((anyBrand) => anyBrand.id === brand.id);
      const index2 = this.favorit_brands.find((anyBrand) => anyBrand.id === brand.id);
      if (!index1 && !index2) {
        this.form.get('brandControl')?.setValue('');
        this.blacklist_brands = [...this.blacklist_brands, brand];
      }
    }
  }

  cancelBlackListBrand(id: number) {
    this.blacklist_brands = this.blacklist_brands.filter((brand) => brand.id !== id)
  }

  onFavoritBrandSelected(brand: IBrand) {
    if (brand) {
      this.form.get('brandControl')?.setValue('');
      const index1 = this.favorit_brands.find((anyBrand) => anyBrand.id === brand.id);
      const index2 = this.blacklist_brands.find((anyBrand) => anyBrand.id === brand.id);
      if (!index1 && !index2) {
        this.form.get('brandControl')?.setValue('');
        this.favorit_brands = [...this.favorit_brands, brand];
      }
    }
  }

  cancelFavoritBrand(id: number) {
    this.favorit_brands = this.favorit_brands.filter((brand) => brand.id !== id)
  }

  onGroupeSelected(groupe: ICompaniesGroups) {
    if (groupe) {
      this.form.get('groupeControl')?.setValue('');
      const index = this.groupes.find((anyGroupe) => anyGroupe.id === groupe.id);
      if (!index) {
        this.groupes = [...this.groupes, groupe];
      }
    }
  }
  cancelGroupe(id: number) {
    this.groupes = this.groupes.filter((groupe) => groupe.id !== id)
  }

  onTagSelected(tag: ITag) {
    if (tag) {
      this.form.get('tagControl')?.setValue('');
      const index = this.tags.find((anyTag) => anyTag.id === tag.id);
      if (!index) {
        this.tags = [...this.tags, tag];
      }
    }
  }

  cancelTag(id: number) {
    this.tags = this.tags.filter((tag) => tag.id !== id)
  }

  onCategorySelected(category: ICategory) {
    if (category) {
      this.form.get('categoryControl')?.setValue('');
      const index = this.categories.find((anyCategory) => anyCategory.id === category.id);
      if (!index) {
        this.categories = [...this.categories, category];
      }
    }
  }

  cancelCategory(id: number) {
    this.categories = this.categories.filter((category) => category.id !== id)
  }

  onFileChange(event: any): void {
    const files = event.target.files as FileList;
    if (files && files.length > 0) {
      Array.from(files).forEach((file: File) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64Data = reader.result as string;
          this.selectedFiles.push({
            data: base64Data.split(',')[1],
            filename: file.name,
            content_type: file.type,
            file: file
          });
        };
        reader.readAsDataURL(file);
      });
    }
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
  }

  hasAtLeastOneFieldFilled(): boolean {
    return Object.keys(this.mainContactForm.value)
      .filter(key => key !== 'lang')
      .some(key => {
        const value = this.mainContactForm.value[key];
        return value !== null && value !== undefined && value !== '' && value !== false;
      });
  }

  isDuplicateEmail(email: string, contacts: IMainContact[]): boolean {
    if (!email) return false;

    const normalizedEmail = email.trim().toLowerCase();

    return contacts.some(contact => contact.email?.trim().toLowerCase() === normalizedEmail);
  }

  save(): boolean | void {
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      return false
    }
    const blacklist_brand_ids: number[] = [];
    const favorit_brand_ids: number[] = [];
    const group_ids: number[] = [];
    const tag_ids: number[] = [];
    const category_ids: number[] = [];
    this.blacklist_brands.forEach((brand) => {
      blacklist_brand_ids.push(brand.id)
    });
    this.favorit_brands.forEach((brand) => {
      favorit_brand_ids.push(brand.id)
    });
    this.groupes.forEach((groupe) => {
      group_ids.push(groupe.id)
    });
    this.tags.forEach((tag) => {
      tag_ids.push(tag.id)
    });
    this.categories.forEach((category) => {
      category_ids.push(category.id)
    })

    const location: ILocation = {
      id: this.customer?.location?.id,
      name: this.locationForm.get('name')?.value ?? '',
      currency: this.currencies.find((currency: ICurrency) => (currency.id) === +this.locationForm.get('currency')?.value),
      tax: this.locationForm.get('tax')?.value ?? '',
      tax_id: this.locationForm.get('tax_id')?.value ?? '',
      custom_discount: this.locationForm.get('custom_discount')?.value ?? '',
      apartment: this.locationForm.get('apartment')?.value ?? '',
      country: this.countries.find((country: ICountry) => (country.name) === this.country),
      city: this.city,
      state: this.states.find((state: IState) => (state.name) === this.state),
      zip: this.zip,
      billing_country: this.countries.find((country: ICountry) => (country.name) === this.billing_country),
      billing_city: this.billing_city,
      billing_state: this.states.find((state: IState) => (state.name) === this.billing_state),
      billing_zip: this.billing_zip,
      billing_apartment: this.locationForm.get('billing_apartment')?.value ?? '',
      is_main: this.CurrentMode === 'edit' ? this.customer!.location!.is_main : this.CurrentMode === 'add' ? false : this.CurrentMode === 'new' ? true : false,
      blacklist_brand_ids: blacklist_brand_ids,
      is_bill_same: this.locationForm.get('is_bill_same')?.value ?? false,
      is_bill_same_as_main: this.locationForm.get('is_bill_same_as_main')?.value ?? false,
      favorit_brand_ids: favorit_brand_ids,
      group_ids: group_ids,
      payment_terms: this.paymentTerms.find((term: IPayment_term) => term.id === +this.locationForm.get('payment_terms')?.value),
      // WB-7370: the Contact step is hidden from the UI when the flag is off, so mainContacts
      // can only ever be a passthrough of whatever the server already returned for this
      // location; pass that through explicitly instead of relying on mainContacts staying
      // untouched.
      contacts_information: this.featureFlagService.traditionalContactsEnabled
        ? this.mainContacts
        : (this.customer?.location?.contacts_information ?? []),
      tag_ids: tag_ids,
      category_ids: category_ids,
      catalogs: this.selectedCatalogs,
      lang: this.lang,
    }

    // Check if any of the steps that need validation are invalid
    const isSomeStepInvalid = [1, 2].some((step: number) => !this.validateStep(step))

    if(isSomeStepInvalid) {
      return; // Exit if any step is invalid
    }

    const payload: Omit<ICustomer, 'id'> = {
      name: this.form.get('name')?.value,
      company_id: this.form.get('company_id')?.value,
      location: location,
      files: this.selectedFiles
    }
    if (this.locationId) {
      this.store.dispatch(UpdateCustomer({ id: this.customer.id, customer: payload }))
    } else if (this.customerId) {
      const ptId = +this.locationForm.get('payment_terms')?.value;
      const erpVal = this.locationForm.get('erp_id')?.value?.trim();
      const taxVal = this.locationForm.get('tax_id')?.value?.trim();
      const createPayload: CreateLocationPayload = {
        name: (this.locationForm.get('name')?.value as string).trim(),
        id_company: this.customerId,
        is_main: location.is_main,
        ...(this.locationForm.get('apartment')?.value?.trim() ? { apartment: this.locationForm.get('apartment')!.value.trim() } : {}),
        ...(this.locationForm.get('billing_apartment')?.value?.trim() ? { billing_apartment: this.locationForm.get('billing_apartment')!.value.trim() } : {}),
        ...(ptId ? { payment_terms: ptId } : {}),
        ...(erpVal ? { erp_id: erpVal.substring(0, 64) } : {}),
        ...(taxVal ? { tax_id: taxVal.substring(0, 64) } : {}),
        // WB-7370: mainContacts can only be non-empty here via the now-hidden Contact step.
        ...(this.featureFlagService.traditionalContactsEnabled && this.mainContacts?.length
          ? { contacts_information: this.mainContacts }
          : {}),
      };
      this.store.dispatch(AddLocation({ payload: createPayload }))
    } else {
      this.store.dispatch(AddCustomer({ customer: payload }))
    }
  }

  editFiles(files: IFile[]): void {
    const dialogRef = this.dialog.open(EditFilesComponent, {
      data: { files },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: IFile[]) => {

      if (result) {
        this.selectedFiles = [...result];
      }
    });
  }

  addNewElement(newElementName: string, type: string) {
    const dialogRef = this.dialog.open(AddElementsComponent, {
      data: {
        name: newElementName,
        type: type
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.autocompleteTriggers.forEach(trigger => trigger.closePanel());
    });
  }

  private convertBase64ToBlob(data: string, content_type: string): Blob {
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: content_type });
  }
  download(data: string, fileName: string, content_type: string) {
    const blob = this.convertBase64ToBlob(data, content_type);
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }
  preview(data: string, content_type: string) {
    const blob = this.convertBase64ToBlob(data, content_type);
    this.dialog.open(FilesDialogPreviewerComponent, {
      data: [blob]
    })
  }
  cancel() {
    this.store.select(state => state.shared.navbarParams).pipe(take(1))
    .subscribe(navbarParams => {
      this.activatedRoute.queryParams.subscribe(params => {
        const queryParams = {
          page: params["page"],
          count: params["count"]
        }
        this.router.navigate([navbarParams.parentPath],
          {
            relativeTo: this.activatedRoute,
            queryParams: queryParams
          }
        )
      });
    });
  }

  canceled() {
    this.currentForm = 'addCustomer';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub => sub.unsubscribe()))
  }

}


